<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="ownerStmts" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="ownerStmtId" selectionMode="multiple"
  [(selection)]="selectedStmts" [loading]="loading" [paginator]="showPaginator()" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Owner Stmt</h1>
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>

        <!--tax preview-->
        <button pButton pRipple class="p-button-success" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
        [disabled]="!selectedStmts?.length" (click)="openTaxPreview()">Generate Tax Preview ({{ selectedStmts?.length || 0 }})</button>

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New Owner Statement +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th [ngStyle]="{'width': '40px'}"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    <tr>
      <th [ngStyle]="{'width': '40px'}"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyCode', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ownerName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ownerAdrState', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ownerAdrCity', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyAdrState', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyAdrCity', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-ownerStmt>
    <tr [pSelectableRow]="ownerStmt">
      <td><p-tableCheckbox [value]="ownerStmt"></p-tableCheckbox></td>
      <td>{{ownerStmt.shortTermRentalId}} </td>
      <td>{{ownerStmt.propertyCode}}</td>
      <td>{{ownerStmt.ownerName}}</td>
      <td>{{ownerStmt.ownerAdrState}}</td>
      <td>{{ownerStmt.ownerAdrCity}}</td>
      <td>{{ownerStmt.propertyAdrState}}</td>
      <td>{{ownerStmt.propertyAdrCity}}</td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(ownerStmt)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>
